<!-- eslint-disable -->
<template lang="pug">
    .countdown
        .warning(v-if="isMobile && isDisableOnMobile")
            svg( version="1.1" id="rotate" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="40px" height="40px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
                xml:space="preserve"
            )
                no-phone-icon
            div {{ $i18n.t('olympiads.olympiads_countdown_isDisabledOnMobile') }}
            router-link.back-button(:to="{name: 'dashboard'}")
                cs-button  {{ $i18n.t('trainer.trainer_browseGames_back') }}
        .countdown__container(v-else)
            transition(
                name="fade"
                enterActiveClass="fade--enter-active",
                enterClass="fade--enter",
                enterToClass="fade--enter-to",
                leaveActiveClass="fade--leave-active",
                leaveClass="fade--leave",
                leaveToClass="fade--leave-to"
            )
                img.countdown__turtle(:src="TURTLE_WITH_CUP", v-if="isTurtleShown")
            transition(
                name="fade"
                enterActiveClass="fade--enter-active",
                enterClass="fade--enter",
                enterToClass="fade--enter-to",
                leaveActiveClass="fade--leave-active",
                leaveClass="fade--leave",
                leaveToClass="fade--leave-to"
            )
                div(v-if="arePhrasesShown")
                    transition-group(
                        name="change-phrase",
                        enterActiveClass="change-phrase--enter-active",
                        enterClass="change-phrase--enter",
                        enterToClass="change-phrase--enter-to",
                        leaveActiveClass="change-phrase--leave-active",
                        leaveClass="change-phrase--leave",
                        leaveToClass="change-phrase--leave-to"
                    )
                        .countdown__phrase(
                            v-for="(item, index) in list",
                            :key="item.id",
                            :class=`{
                                'countdown__phrase--main': item.main
                            }`
                        ) {{ item.phrase }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import trainerConfig from '../../../config/trainer.json'
    import MobileDetect from 'mobile-detect/mobile-detect.js'
    import NoPhoneIcon from '../../svg/NoPhone.vue'
    import TURTLE_WITH_CUP from '../../../assets/images/TurtleWithCup.svg';

    const GAMES_DISABLED_ON_MOBILE = [
        'Schulte', 'Scanner',
        'WordsField', 'Texts',
    ];

    export default {
        components: {
            NoPhoneIcon,
        },
        props: ['levels'],
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        },
        data() {
            return {
                isTurtleShown: true,
                arePhrasesShown: false,
                list: [
                    {id: 1, phrase: this.$i18n.t('olympiads.olympiads_countdown_go'), main: false},
                    {id: 2, phrase: this.$i18n.t('olympiads.olympiads_countdown_ready'), main: false},
                    {id: 3, phrase: this.$i18n.t('olympiads.olympiads_countdown_steady'), main: false},
                    {id: 4, phrase: this.$i18n.t('olympiads.olympiads_countdown_go'), main: false},
                    {id: 5, phrase: this.$i18n.t('olympiads.olympiads_countdown_ready'), main: true, visible: true},
                    {id: 6, phrase: this.$i18n.t('olympiads.olympiads_countdown_steady'), main: false, visible: true},
                    {id: 7, phrase: this.$i18n.t('olympiads.olympiads_countdown_go'), main: false, visible: true},
                    {id: 8, phrase: this.$i18n.t('olympiads.olympiads_countdown_ready'), main: false},
                    {id: 9, phrase: this.$i18n.t('olympiads.olympiads_countdown_steady'), main: false},
                ],
                isMobile: false,
                isDisableOnMobile: false,
                TURTLE_WITH_CUP
            };
        },
        mounted() {
            this.isMobile = Boolean((new MobileDetect(window.navigator.userAgent)).phone());
            this.isDisableOnMobile = this.levels.some(level => {
                return level.registeredUsers.some(user => user.id === this.user.id) && level.stages.some(stage => {
                    return stage.games.some(game => {
                        return GAMES_DISABLED_ON_MOBILE.includes(game.slug);
                    })
                })
            })
            if (!this.isMobile || !this.isDisableOnMobile) {
                this.showPreparatoryTurtle();
            }
            this.loadSound();
        },
        methods: {
            showPreparatoryTurtle() {
                let instance = this.$createjs.Sound.play("startSound");
                instance.on('complete', () => {
                    this.isTurtleShown = false;
                    setTimeout(() => {
                        this.arePhrasesShown = true;
                        this.startCount();
                    }, 500);
                });
            },
            loadSound() {
                this.$createjs.Sound.alternateExtensions = ["mp3"];
                this.$createjs.Sound.registerSounds(trainerConfig.countdownSound);
            },
            startCount() {
                this.$createjs.Sound.play("beep");
                this.interval = setInterval(() => {
                    if (this.list.find(el => el.main).phrase === this.$i18n.t('olympiads.olympiads_countdown_go')) {
                        this.$emit('countFinished');
                        clearInterval(this.interval);
                        return;
                    }
                    this.changePhrase();
                    this.$createjs.Sound.play("beep");
                }, 1000);
            },
            changePhrase() {
                this.list.push(this.list.shift());
                let index = this.list.findIndex(el => el.main);
                this.list[index + 1].main = true;
                this.list[index].main = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fade--enter-active, .fade--leave-active {
        transition: opacity .5s;
    }

    .fade--enter, .fade--leave-to {
        opacity: 0;
    }

    .change-phrase--enter, .change-phrase--leave-to {
        opacity: 0;
    }

    .change-phrase--leave-active {
        position: absolute;
    }

    .countdown {
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: $z-index-modal;
        left: 0;
        top: 0;
        background: url('../../../assets/images/olympiads/pattern.png') $x-color-white;
        display: flex;
        align-items: center;
        justify-content: center;

        &__container {
            width: 100%;
            text-align: center;
        }

        &__phrase {
            transition: all .5s;
            width: 100%;
            text-align: center;
            font-size: 8vw;
            letter-spacing: $space-small;
            font-weight: $font-weight-bold;
            opacity: 0;
            will-change: transform;

            &--main {
                opacity: 1;
                font-size: 11vw;
            }
        }

        &__turtle {
            vertical-align: middle;
            max-height: 50vh;
            max-width: 100vw;
        }
    }

    .back-button {
        margin-top: $space-base
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>
